/** Single source of truth for marketing + in-app legal document versioning. */
export const LEGAL_VERSION = '1.0';
export const LEGAL_LAST_UPDATED = '2026-06-02';

export function formatLegalLastUpdated(lang: 'it' | 'en'): string {
  const d = new Date(`${LEGAL_LAST_UPDATED}T12:00:00`);
  return new Intl.DateTimeFormat(lang === 'it' ? 'it-IT' : 'en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(d);
}

export function formatLegalHeaderLine(lang: 'it' | 'en'): string {
  const date = formatLegalLastUpdated(lang);
  return lang === 'it'
    ? `Ultimo aggiornamento: ${date} — Versione ${LEGAL_VERSION}`
    : `Last updated: ${date} — Version ${LEGAL_VERSION}`;
}
